import React from 'react';
import { Button, Checkbox, InputNumber, Select } from 'antd';
import {
  DEFAULT_MAP_PROVIDER_SETTINGS,
  normalizeMapProviderSettings
} from '../../../utils/mapProviderSettings';

const APP_BASEMAP_OPTIONS = [
  { value: 'dark', label: '暗色地图' },
  { value: 'satellite', label: '卫星影像' },
  { value: 'street', label: '街道地图' },
  { value: 'terrain', label: '地形图' }
];

/** 管理后台 · 地图配置 · 单兵 App */
export function buildAppMapSettingsTab(context) {
  const { shouldShowPage, handleSaveSystemSettings, updateSystemSettings, systemSettings } = context;

  if (
    !shouldShowPage?.('单兵 App 设置')
    && !shouldShowPage?.('底图源设置')
    && !shouldShowPage?.('地图设置')
    && !shouldShowPage?.('系统设置')
  ) {
    return null;
  }

  const mapSettings = normalizeMapProviderSettings(systemSettings.mapProviderSettings);
  const appMap = mapSettings.appMap || DEFAULT_MAP_PROVIDER_SETTINGS.appMap;
  const overlays = appMap.overlays || {};

  const patchAppMap = (patch) => updateSystemSettings((settings) => {
    const current = normalizeMapProviderSettings(settings.mapProviderSettings);
    return {
      ...settings,
      mapProviderSettings: normalizeMapProviderSettings({
        ...(settings.mapProviderSettings || {}),
        appMap: {
          ...current.appMap,
          ...patch,
          overlays: {
            ...current.appMap.overlays,
            ...(patch.overlays || {})
          }
        }
      })
    };
  });

  const resetAppMap = () => patchAppMap({
    ...DEFAULT_MAP_PROVIDER_SETTINGS.appMap,
    overlays: { ...DEFAULT_MAP_PROVIDER_SETTINGS.appMap.overlays }
  });

  return {
    key: 'app_map_settings',
    label: '单兵 App',
    children: (
      <div>
        <h3>单兵 App 地图默认</h3>
        <div style={{ marginBottom: 16 }}>
          <Button type="primary" onClick={handleSaveSystemSettings}>保存设置</Button>
          <Button style={{ marginLeft: 8 }} onClick={resetAppMap}>重置默认</Button>
        </div>
        <p style={{ color: '#666', fontSize: 13, marginBottom: 16 }}>
          App 首次打开时从服务器读取以下配置并加载对应图源；暗色图源使用免 Key 的深色底图。
          「显示最近几天坐标」同时作用于指挥页自动上图，以及单兵地图拉取自己的上报历史。
        </p>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, minmax(0, 1fr))', gap: 16 }}>
          <div>
            <div>默认底图</div>
            <Select
              style={{ width: '100%' }}
              value={appMap.defaultBasemap || 'dark'}
              onChange={(defaultBasemap) => patchAppMap({ defaultBasemap })}
              options={APP_BASEMAP_OPTIONS}
            />
          </div>
          <div>
            <div style={{ marginBottom: 8 }}>默认叠加层</div>
            <Checkbox
              checked={!!overlays.contour}
              onChange={(e) => patchAppMap({ overlays: { contour: e.target.checked } })}
            >
              等高线/山影
            </Checkbox>
            <Checkbox
              style={{ marginLeft: 12 }}
              checked={!!overlays.roads}
              onChange={(e) => patchAppMap({ overlays: { roads: e.target.checked } })}
            >
              路网
            </Checkbox>
            <Checkbox
              style={{ marginLeft: 12 }}
              checked={!!overlays.places}
              onChange={(e) => patchAppMap({ overlays: { places: e.target.checked } })}
            >
              地点
            </Checkbox>
          </div>
          <div>
            <Checkbox
              checked={appMap.allowUserSwitch !== false}
              onChange={(e) => patchAppMap({ allowUserSwitch: e.target.checked })}
            >
              允许队员在 App 内切换图层
            </Checkbox>
          </div>
          <div>
            <div>指挥端 / 单兵地图显示最近几天坐标</div>
            <InputNumber
              style={{ width: '100%', marginTop: 6 }}
              min={0}
              max={30}
              value={appMap.trackDisplayDays ?? 7}
              onChange={(trackDisplayDays) => patchAppMap({ trackDisplayDays: trackDisplayDays ?? 7 })}
            />
            <p style={{ fontSize: 12, color: '#666', marginTop: 4, marginBottom: 0 }}>
              单兵每次上报会写入轨迹库。指挥页自动画出最近 N 天折线；填 0 则只显示最新点、不自动拉历史。
              手机本地「轨迹点 50」是离线缓存上限，不是指挥端点数。
            </p>
          </div>
        </div>
      </div>
    )
  };
}
